import { useBoolean } from '@dreryk/react-common';

import { MagistralDrugCreateModal } from './MagistralDrugCreateModal';
import { OnMagistralDrugCreated } from './MagistralDrugCreateForm.types';

type MagistralDrugCreateModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type MagistralDrugCreateModalOpenerProps = {
   readonly children: (renderProps: MagistralDrugCreateModalOpenerChildrenRenderProps) => JSX.Element;
   readonly onMagistralDrugCreated: OnMagistralDrugCreated;
};

export const MagistralDrugCreateModalOpener = (props: MagistralDrugCreateModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);
   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <MagistralDrugCreateModal onMagistralDrugCreated={props.onMagistralDrugCreated} onClose={closeModal} />
         ) : null}
      </>
   );
};
